import * as angular from 'angular';

import './styling.scss';

import * as AcceptTermsAndConditionsModal from './accept-terms-and-conditions';
import * as AchPaymentModal from './ach-payment';
import * as BaseModal from 'common/source/modals/base-modal';
import * as CcPaymentModal from './cc-payment';
import * as ContactMeConfirmationModal from './contact-me-confirmation';
import * as EscrowModal from './escrow-payment';
import * as LoginCta from './login-cta';
import * as MobileAchPayNowModal from './mobile-ach-pay-now';
import * as MobileCcPayNowModal from './mobile-cc-pay-now';
import * as MobileEscrowPayNowModal from './mobile-escrow-pay-now';
import * as NotifyLenderModal from './notify-lender';
import * as UpdateEscrowLenderModal from './update-escrow-lender';
import * as MobileAppDownloadLoginModal from './mobile-app-download-modal';

const module = angular.module('modalComponents', [
    AcceptTermsAndConditionsModal.module.name,
    AchPaymentModal.module.name,
    BaseModal.module.name,
    CcPaymentModal.module.name,
    ContactMeConfirmationModal.module.name,
    EscrowModal.module.name,
    LoginCta.module.name,
    MobileAchPayNowModal.module.name,
    MobileCcPayNowModal.module.name,
    MobileEscrowPayNowModal.module.name,
    NotifyLenderModal.module.name,
    UpdateEscrowLenderModal.module.name,
    MobileAppDownloadLoginModal.module.name
]);

export { module };
